import axios from 'axios'
import { METHODS, MODAL_TITLE, MODAL_TYPE, routes } from '../../../../utils/constants'
import { setModal } from '../../../../redux/slices/Modal/modalSlice'
import { useDispatch } from 'react-redux'

const useProductPermission = ({
  setActiveButton,
  clientMmId,
  token,
  activeButton,
  setCurrencyPermissionData,
  setCopyCurrencyPermissionData,
  currencyPermissionData,
  userType,
  productPermissionError,
  setProductPermissionError,
  setDeleteCurrencyPermissionData,
  currencyNormalize
}) => {
  const dispatch = useDispatch()

  const handleNavButtonClick = async buttonName => {
    setActiveButton(buttonName)
  }

  const getCurrencyPermissionData = async () => {
    let url
    if (userType === 'client') {
      url = process.env.REACT_APP_SERVER_URL.concat(routes.clientPermission, '/', clientMmId)
    } else {
      url = process.env.REACT_APP_SERVER_URL.concat(routes.marketMakerPermission, '/', clientMmId)
    }
    try {
      const response = await axios.get(url, { headers: { Authorization: token } })
      setCurrencyPermissionData(response.data)
      setCopyCurrencyPermissionData(response.data)
      setDeleteCurrencyPermissionData([])
    } catch (error) {
      console.log(error)
    }
  }

  const handleTenorChange = (e, tenor) => {
    const newCurrencyString = [
      ...new Set(e.target.value.split(',').map(c => c.trim().toUpperCase()))
    ]

    const updated = currencyPermissionData[activeButton].map(item =>
      item.tenor_value === tenor.tenor_value ? { ...item, currency_list: newCurrencyString } : item
    )

    setCurrencyPermissionData(prev => ({
      ...prev,
      [activeButton]: updated
    }))
  }

  const handelPermissionClick = () => {
    dispatch(
      setModal({
        type: MODAL_TYPE.PERMISSION,
        title: MODAL_TITLE.ADD_PERMISSIONS,
        isOpen: true,
        method: METHODS.POST,
        data: { clientMmId, userType }
      })
    )
  }

  const handelRemovePermission = (activeButton, index) => {
    setDeleteCurrencyPermissionData(prev => {
      const data = [
        ...prev,
        {
          product_type: activeButton,
          tenor_value: currencyPermissionData[activeButton][index].tenor_value
        }
      ]
      return data
    })

    setCurrencyPermissionData(prev => {
      const updated = { ...prev } // shallow copy of prev
      const updatedList = [...updated[activeButton]] // shallow copy of array

      updatedList.splice(index, 1) // remove item

      if (updatedList.length === 0) {
        delete updated[activeButton]
      } else {
        updated[activeButton] = updatedList
      }

      return updated
    })
  }

  const handelFocus = (e, tenor) => {
    const productPermissionErrorsCopy = JSON.parse(JSON.stringify(productPermissionError))
    if (activeButton in productPermissionErrorsCopy) {
      delete productPermissionErrorsCopy[activeButton][tenor]

      if (Object.keys(productPermissionErrorsCopy[activeButton]).length === 0) {
        delete productPermissionErrorsCopy[activeButton]
      }
    }
    setProductPermissionError(productPermissionErrorsCopy)
  }

  const handelBlur = (e, tenor) => {
    const { value } = e.target

    const productPermissionErrorsCopy = JSON.parse(JSON.stringify(productPermissionError))
    if (value === '') {
      if (
        productPermissionErrorsCopy[activeButton] &&
        !productPermissionErrorsCopy[activeButton][tenor]
      ) {
        delete productPermissionErrorsCopy[activeButton][tenor]
        setProductPermissionError(productPermissionErrorsCopy)
      }
      return
    }
    const errorFlag = value
      .split(',')
      .filter(c => !currencyNormalize[c] || c.length !== 3)
      .join(',')

    if (String(value).endsWith(',')) {
      setProductPermissionError({
        ...productPermissionError,
        [activeButton]: {
          [tenor]: `you need to insert a currency after ( , )`
        }
      })
    }
    if (errorFlag) {
      setProductPermissionError({
        ...productPermissionError,
        [activeButton]: {
          [tenor]: `The following currency code(s) are invalid: ${errorFlag}`
        }
      })
    }
  }

  return {
    handleNavButtonClick,
    handleTenorChange,
    handelPermissionClick,
    getCurrencyPermissionData,
    handelBlur,
    handelFocus,
    handelRemovePermission
  }
}

export default useProductPermission
